export default {
    directorioMatriz: null,
    directorioMatrizObj: null
}